import { REPORT_EXPORTED } from './export-report-actions';

const initialState = {
    key: null,
    resourcesMethod: null
};

/**
 * Export Report Reducer
 *
 * Consumes REPORT_EXPORTED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case REPORT_EXPORTED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/sub-heading/export-report/export-report-reducer.js